<app-toast></app-toast>
<app-spinner></app-spinner>
<div class="container-fluid">
  <div class="row">
    <main class="col-md-12 ms-sm-auto">
      <router-outlet></router-outlet>
    </main>
  </div>
</div>
